import { ColumnHeaderProps } from '../types';

export function PipelineColumnHeader({ title, subtitle }: ColumnHeaderProps) {
    return (
        <div className="text-center mb-4">
            <div className="text-sm font-semibold text-primary mb-1">
                {title}
            </div>
            <div className="text-xs text-muted-foreground">{subtitle}</div>
        </div>
    );
}
